import { Box } from '@mui/material';
import { Typography, Button, colors } from '@sweep-io/sweep-design';
import { BaseDialog } from '../common/dialogs/BaseDialog';
import { openIntercom } from '../dashboard/customerSupportHelper';
import subscriptionRequiredImg from './subscriptionRequiredImg.png';

interface SubscriptionRequiredDialogProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  text: string;
}

const SubscriptionRequiredDialog = ({
  isOpen,
  onClose,
  title,
  text,
}: SubscriptionRequiredDialogProps) => {
  const handleChatWithUs = () => {
    openIntercom();
    onClose();
  };

  return (
    <BaseDialog
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: '726px',
          maxWidth: '726px',
          padding: 0,
          overflow: 'hidden',
        },
      }}
    >
      <Box display="flex" height="100%">
        <Box
          sx={{
            width: '296px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            src={subscriptionRequiredImg}
            alt={'subscription required image'}
            style={{ width: '100%', height: '100%' }}
          />
        </Box>

        <Box
          sx={{
            flex: 1,
            padding: '24px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'flex-start',
              gap: 2,
            }}
          >
            <Typography variant="h2">{title}</Typography>
            <Typography variant="body" color={colors.grey[700]}>
              {text}
            </Typography>
          </Box>

          <Box display="flex" justifyContent="flex-end">
            <Button onClick={handleChatWithUs}>Chat with us</Button>
          </Box>
        </Box>
      </Box>
    </BaseDialog>
  );
};

export default SubscriptionRequiredDialog;
